import { render, staticRenderFns } from "./interviewList.vue?vue&type=template&id=25567f72&"
import script from "./interviewList.vue?vue&type=script&lang=js&"
export * from "./interviewList.vue?vue&type=script&lang=js&"
import style0 from "./interviewList.vue?vue&type=style&index=0&id=25567f72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports